import TreeBuilder from "./TreeBuilder";
import GroupTreeNode from "../../hierarchySelector/tree/GroupTreeNode";
import UserTreeNode from "../../hierarchySelector/tree/UserTreeNode";
import DisabledUsersParentTreeNode from "../../hierarchySelector/tree/DisabledUsersParentTreeNode";

export default class UserSelectorTreeBuilder extends TreeBuilder {
    constructor(rootNode, users, groupsMap, groupsOrder, observer, getGroupIdFromUserCallback) {
        super(rootNode, users, groupsMap, groupsOrder);
        this.observer = observer;
        this.getGroupIdFromUserCallback = getGroupIdFromUserCallback;
    }

    createTreeNodeForFirstLevelEntity(group) {
        return new GroupTreeNode(group);
    }

    createTreeNodeForSecondLevelEntity(user) {
        return new UserTreeNode(user);
    }

    createDisabledNodesParentForSecondLevelEntity(parentId) {
        return new DisabledUsersParentTreeNode(parentId);
    }

    getSecondLevelEntityParentId(user) {
        return this.getGroupIdFromUserCallback(user);
    }

    isFirstLevelEntityEnabled() {
        return true;
    }

    isSecondLevelEntityEnabled(user) {
        return user.isActive();
    }

    onTreeNodeForFirstLevelEntityAdded(treeNode) {
        this.observer.groupNodeAdded(treeNode);
    }

    onTreeNodeForSecondLevelEntityAdded(treeNode) {
        this.observer.userNodeAdded(treeNode);
    }

    onDisabledNodesParentForSecondLevelEntitiesAdded(treeNode) {
        this.observer.disabledUsersParentNodeAdded(treeNode);
    }
}



// WEBPACK FOOTER //
// ./web/js/usersSelector/builder/UserSelectorTreeBuilder.js